import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Timeline = () => {
  const { t } = useTranslation();
  const [events, setEvents] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);

  useEffect(() => {
    const fetchTimelineData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/Timeline`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);  // turns string into array of objects
        console.log("Parsed Events:", events);
        setEvents(events);
      } catch (error) {
        console.error("Error fetching timeline data:", error);
      }
    };

    fetchTimelineData();
  }, []);

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 150;
      scrollRef.current.scrollLeft +=
        direction === "left" ? -scrollAmount : scrollAmount;
    }
  };

  return (
    <div className="w-full flex flex-col items-center p-4 bg-[#1a2340] text-white">
      <h2 className="text-2xl font-bold text-yellow-400 mb-12 mt-20">
        {t("timeline.yslearn Through The Years")}
      </h2>
      {/* Timeline Navigation */}
      <div className="relative w-full flex items-center">
        {/* Left Arrow */}
        <button
          onClick={() => handleScroll("left")}
          className="!absolute left-0 z-10 bg-gray-800 text-white p-2 rounded-full"
        >
          <FaChevronLeft size={20} />
        </button>

        {/* Timeline */}
        <div
          ref={scrollRef}
          className="flex overflow-hidden whitespace-nowrap scrollbar-hide mx-10 border-t-0  relative"
        >
          {events?.map((event, index) => (
            <div
              key={index}
              className={`cursor-pointer flex flex-col items-center mx-6 p-2 ${activeIndex === index ? "bg-blue-500 text-white" : ""
                }`}
              onClick={() => setActiveIndex(index)}
            >
              <div className="text-lg font-semibold">{event.year}</div>
              <div className="text-sm">{event.month}</div>
            </div>
          ))}
          <div className="!absolute top-1/2 left-0 w-full border-dashed border-t-2 border-gray-400 -z-10"></div>
        </div>

        {/* Right Arrow */}
        <button
          onClick={() => handleScroll("right")}
          className="!absolute right-0 z-10 bg-gray-800 text-white p-2 rounded-full"
        >
          <FaChevronRight size={20} />
        </button>
      </div>

      {/* Active Event Details */}
      <div className="w-full max-w-3xl p-6 mt-4  rounded-lg shadow-lg mt-18">
        <h2 className="text-xl font-bold text-white text-center mb-6 mt-18">
          {events[activeIndex]?.title}
        </h2>
        <p className="text-white text-center mb-16">
          {events[activeIndex]?.description}
        </p>
      </div>
    </div>
  );
};

export default Timeline;
